// Quiz logic — questions, scoring map, and skill catalog.
// Bilingual: SKILLS_BY_LANG / QUESTIONS_BY_LANG keyed by "es" | "en".
// Identical scoring keys/weights across languages.

const SKILLS_ES = {
  customer_success: {
    name: "Customer Success Remoto",
    blurb: "Acompañas clientes para que ganen con tu producto. Tu empatía vale en dólares.",
    icon: "Heart",
  },
  project_manager: {
    name: "Project Manager Remoto",
    blurb: "Coordinas piezas, plazos y personas en async. Tu cabeza ya pensaba así.",
    icon: "GitBranch",
  },
  sales_dev: {
    name: "Sales Development Rep",
    blurb: "Abres conversaciones y mueves la aguja. Si vendiste cara a cara, vendes por DM.",
    icon: "Target",
  },
  community: {
    name: "Community Manager",
    blurb: "Construyes vínculos a escala. Comunicas con calor — eso no se automatiza.",
    icon: "Users",
  },
  instructional: {
    name: "Diseño Instruccional",
    blurb: "Conviertes conocimiento en experiencia. Tu pedagogía se multiplica online.",
    icon: "BookOpen",
  },
  people_ops: {
    name: "People Ops Remote",
    blurb: "Onboarding, cultura y bienestar a distancia. Donde antes leías a tu equipo en persona, ahora lo haces async.",
    icon: "Sprout",
  },
  exec_assistant: {
    name: "Asistente Ejecutiva Virtual",
    blurb: "Operación silenciosa que sostiene a líderes ocupados. Tu organización es oro.",
    icon: "Calendar",
  },
  bookkeeping: {
    name: "Bookkeeping & Finance Ops",
    blurb: "Mantienes los números en orden. Clientes en USD desde tu computadora.",
    icon: "Calculator",
  },
  ops: {
    name: "Operations Manager",
    blurb: "Diseñas sistemas que escalan sin ti presente. El cerebro detrás del telón.",
    icon: "Settings",
  },
  content: {
    name: "Content Strategist",
    blurb: "Conviertes ideas en piezas que mueven negocios. Tu voz es el activo.",
    icon: "PenLine",
  },
  ux_research: {
    name: "UX Research",
    blurb: "Escuchas a usuarios y traduces señales en decisiones. La escucha activa, en versión digital.",
    icon: "Search",
  },
  account: {
    name: "Account Manager",
    blurb: "Cuidas clientes clave y los haces crecer. Relaciones por video, igual de poderosas.",
    icon: "Handshake",
  },
};

const SKILLS_EN = {
  customer_success: {
    name: "Remote Customer Success",
    blurb: "You guide clients so they win with your product. Empathy is the currency.",
    icon: "Heart",
  },
  project_manager: {
    name: "Remote Project Manager",
    blurb: "You coordinate pieces, deadlines and people asynchronously. Your mind already worked this way.",
    icon: "GitBranch",
  },
  sales_dev: {
    name: "Sales Development Rep",
    blurb: "You open conversations and move the needle. If you sold face-to-face, you can sell over DM.",
    icon: "Target",
  },
  community: {
    name: "Community Manager",
    blurb: "You build relationships at scale. Warmth that doesn’t get automated.",
    icon: "Users",
  },
  instructional: {
    name: "Instructional Design",
    blurb: "You turn knowledge into experience. Your teaching scales online.",
    icon: "BookOpen",
  },
  people_ops: {
    name: "People Ops Remote",
    blurb: "Onboarding, culture and well-being from a distance. Reading the room — now async.",
    icon: "Sprout",
  },
  exec_assistant: {
    name: "Virtual Executive Assistant",
    blurb: "The quiet operation behind busy leaders. Your organization is gold.",
    icon: "Calendar",
  },
  bookkeeping: {
    name: "Bookkeeping & Finance Ops",
    blurb: "You keep the numbers in order. Clients in USD from your laptop.",
    icon: "Calculator",
  },
  ops: {
    name: "Operations Manager",
    blurb: "You design systems that scale without you. The brain behind the curtain.",
    icon: "Settings",
  },
  content: {
    name: "Content Strategist",
    blurb: "You turn ideas into pieces that move businesses. Your voice is the asset.",
    icon: "PenLine",
  },
  ux_research: {
    name: "UX Research",
    blurb: "You listen to users and translate signals into decisions. Active listening, digital edition.",
    icon: "Search",
  },
  account: {
    name: "Account Manager",
    blurb: "You take care of key clients and grow them. Relationships over video — just as powerful.",
    icon: "Handshake",
  },
};

const QUESTIONS_ES = [
  {
    id: "rol",
    eyebrow: "Pregunta 01 / 06",
    title: "¿Cuál ha sido tu rol predominante?",
    subtitle: "Elige el que más se parezca a tu día a día actual.",
    options: [
      { label: "Atención al cliente o ventas presenciales", weights: { customer_success: 3, sales_dev: 3, account: 2, community: 2 } },
      { label: "Administración, asistencia o coordinación", weights: { exec_assistant: 3, ops: 2, project_manager: 2, bookkeeping: 1 } },
      { label: "Liderazgo o supervisión de equipos", weights: { ops: 3, project_manager: 3, people_ops: 2, account: 1 } },
      { label: "Educación, formación o capacitación", weights: { instructional: 3, content: 2, community: 1, customer_success: 1 } },
      { label: "Recursos humanos / gestión de personas", weights: { people_ops: 3, customer_success: 2, community: 2 } },
      { label: "Operaciones, contabilidad o área técnica", weights: { ops: 3, bookkeeping: 3, project_manager: 1 } },
      { label: "Creativo / comunicación / marketing", weights: { content: 3, community: 2, ux_research: 1, instructional: 1 } },
    ],
  },
  {
    id: "energiza",
    eyebrow: "Pregunta 02 / 06",
    title: "¿Qué actividad te energiza más?",
    subtitle: "Lo que después de hacerlo no te deja cansada.",
    options: [
      { label: "Conversar y resolver problemas de personas", weights: { customer_success: 3, community: 2, account: 2, ux_research: 1 } },
      { label: "Organizar procesos, planear, ordenar caos", weights: { project_manager: 3, ops: 3, exec_assistant: 2 } },
      { label: "Vender, convencer o cerrar acuerdos", weights: { sales_dev: 3, account: 3, community: 1 } },
      { label: "Crear cosas nuevas (texto, diseño, ideas)", weights: { content: 3, instructional: 2, ux_research: 2 } },
      { label: "Enseñar o explicar conceptos complejos", weights: { instructional: 3, content: 2, customer_success: 1 } },
      { label: "Investigar, analizar, conectar puntos", weights: { ux_research: 3, content: 1, ops: 1, bookkeeping: 1 } },
    ],
  },
  {
    id: "fortaleza",
    eyebrow: "Pregunta 03 / 06",
    title: "Tus colegas dirían que tu mayor fortaleza es…",
    subtitle: "La palabra que aparece una y otra vez en feedback.",
    options: [
      { label: "Empatía y escucha activa", weights: { customer_success: 3, people_ops: 2, ux_research: 2, community: 2 } },
      { label: "Organización y método", weights: { ops: 3, project_manager: 3, exec_assistant: 3, bookkeeping: 2 } },
      { label: "Comunicación clara y persuasiva", weights: { content: 3, sales_dev: 2, account: 2, instructional: 2 } },
      { label: "Iniciativa — no espero a que me digan qué hacer", weights: { project_manager: 2, sales_dev: 2, ops: 2, content: 1 } },
      { label: "Análisis y criterio para decidir", weights: { ux_research: 3, bookkeeping: 2, ops: 2, content: 1 } },
      { label: "Paciencia y constancia", weights: { customer_success: 2, instructional: 2, bookkeeping: 2, people_ops: 2 } },
    ],
  },
  {
    id: "tech",
    eyebrow: "Pregunta 04 / 06",
    title: "Tu relación con la tecnología.",
    subtitle: "Sé honesta — no hay respuesta mala.",
    options: [
      { label: "Cero miedo, aprendo herramientas nuevas rápido", weights: { project_manager: 2, content: 2, ux_research: 2, ops: 1, sales_dev: 1 } },
      { label: "Manejo lo básico (email, video, hoja de cálculo)", weights: { exec_assistant: 2, customer_success: 2, account: 2, community: 1 } },
      { label: "Me cuesta pero quiero aprender, paso a paso", weights: { customer_success: 2, instructional: 2, people_ops: 2, exec_assistant: 1 } },
      { label: "Soy bastante técnica — Excel avanzado, automatizaciones", weights: { bookkeeping: 3, ops: 3, project_manager: 2, ux_research: 1 } },
    ],
  },
  {
    id: "dia",
    eyebrow: "Pregunta 05 / 06",
    title: "En tu día ideal de trabajo remoto preferirías…",
    subtitle: "Sin filtros, ¿cómo se ve la mañana perfecta?",
    options: [
      { label: "Pocas conversaciones, profundas, con clientes clave", weights: { account: 3, customer_success: 2, ux_research: 2 } },
      { label: "Coordinar muchas piezas y personas", weights: { project_manager: 3, ops: 2, community: 1 } },
      { label: "Tareas concretas y ejecutar con foco profundo", weights: { bookkeeping: 3, content: 2, exec_assistant: 2, instructional: 1 } },
      { label: "Crear, diseñar, escribir", weights: { content: 3, instructional: 2, ux_research: 1 } },
      { label: "Estrategia de alto nivel y pensar el panorama", weights: { ops: 3, project_manager: 2, ux_research: 2, account: 1 } },
      { label: "Hablar con muchas personas y construir comunidad", weights: { community: 3, sales_dev: 2, customer_success: 1 } },
    ],
  },
  {
    id: "experiencia",
    eyebrow: "Pregunta 06 / 06",
    title: "Años de experiencia profesional total.",
    subtitle: "Cuenta toda tu vida laboral, no sólo el último rol.",
    options: [
      { label: "1 a 3 años", weights: { customer_success: 2, community: 2, content: 1, sales_dev: 1 } },
      { label: "4 a 7 años", weights: { project_manager: 2, account: 2, content: 1, ux_research: 1 } },
      { label: "8 a 15 años", weights: { ops: 2, people_ops: 2, account: 2, project_manager: 1 } },
      { label: "Más de 15 años", weights: { ops: 3, people_ops: 2, instructional: 2, account: 1 } },
    ],
  },
];

const QUESTIONS_EN = [
  {
    id: "rol",
    eyebrow: "Question 01 / 06",
    title: "What has been your main role?",
    subtitle: "Pick the one closest to your current daily work.",
    options: [
      { label: "In-person customer service or sales", weights: QUESTIONS_ES[0].options[0].weights },
      { label: "Administration, assistance or coordination", weights: QUESTIONS_ES[0].options[1].weights },
      { label: "Leadership or team supervision", weights: QUESTIONS_ES[0].options[2].weights },
      { label: "Education, training or teaching", weights: QUESTIONS_ES[0].options[3].weights },
      { label: "Human resources / people management", weights: QUESTIONS_ES[0].options[4].weights },
      { label: "Operations, accounting or technical work", weights: QUESTIONS_ES[0].options[5].weights },
      { label: "Creative / communications / marketing", weights: QUESTIONS_ES[0].options[6].weights },
    ],
  },
  {
    id: "energiza",
    eyebrow: "Question 02 / 06",
    title: "What activity energizes you most?",
    subtitle: "The kind of work that doesn’t leave you drained afterwards.",
    options: [
      { label: "Talking to people and solving their problems", weights: QUESTIONS_ES[1].options[0].weights },
      { label: "Organizing processes, planning, turning chaos into order", weights: QUESTIONS_ES[1].options[1].weights },
      { label: "Selling, convincing or closing deals", weights: QUESTIONS_ES[1].options[2].weights },
      { label: "Creating new things (writing, design, ideas)", weights: QUESTIONS_ES[1].options[3].weights },
      { label: "Teaching or explaining complex concepts", weights: QUESTIONS_ES[1].options[4].weights },
      { label: "Researching, analyzing, connecting dots", weights: QUESTIONS_ES[1].options[5].weights },
    ],
  },
  {
    id: "fortaleza",
    eyebrow: "Question 03 / 06",
    title: "Your colleagues would say your biggest strength is…",
    subtitle: "The word that comes up again and again in feedback.",
    options: [
      { label: "Empathy and active listening", weights: QUESTIONS_ES[2].options[0].weights },
      { label: "Organization and method", weights: QUESTIONS_ES[2].options[1].weights },
      { label: "Clear and persuasive communication", weights: QUESTIONS_ES[2].options[2].weights },
      { label: "Initiative — I don’t wait to be told what to do", weights: QUESTIONS_ES[2].options[3].weights },
      { label: "Analysis and judgement to decide", weights: QUESTIONS_ES[2].options[4].weights },
      { label: "Patience and consistency", weights: QUESTIONS_ES[2].options[5].weights },
    ],
  },
  {
    id: "tech",
    eyebrow: "Question 04 / 06",
    title: "Your relationship with technology.",
    subtitle: "Be honest — there’s no wrong answer.",
    options: [
      { label: "Zero fear, I learn new tools quickly", weights: QUESTIONS_ES[3].options[0].weights },
      { label: "I handle the basics (email, video, spreadsheets)", weights: QUESTIONS_ES[3].options[1].weights },
      { label: "It’s hard for me but I want to learn step by step", weights: QUESTIONS_ES[3].options[2].weights },
      { label: "Quite technical — advanced spreadsheets, automations", weights: QUESTIONS_ES[3].options[3].weights },
    ],
  },
  {
    id: "dia",
    eyebrow: "Question 05 / 06",
    title: "On an ideal remote workday you would prefer…",
    subtitle: "No filters — what does the perfect morning look like?",
    options: [
      { label: "Few but deep conversations with key clients", weights: QUESTIONS_ES[4].options[0].weights },
      { label: "Coordinating many pieces and people", weights: QUESTIONS_ES[4].options[1].weights },
      { label: "Concrete tasks and deep-focus execution", weights: QUESTIONS_ES[4].options[2].weights },
      { label: "Creating, designing, writing", weights: QUESTIONS_ES[4].options[3].weights },
      { label: "High-level strategy and big-picture thinking", weights: QUESTIONS_ES[4].options[4].weights },
      { label: "Talking to many people and building community", weights: QUESTIONS_ES[4].options[5].weights },
    ],
  },
  {
    id: "experiencia",
    eyebrow: "Question 06 / 06",
    title: "Total years of professional experience.",
    subtitle: "Count your full working life, not just your latest role.",
    options: [
      { label: "1 to 3 years", weights: QUESTIONS_ES[5].options[0].weights },
      { label: "4 to 7 years", weights: QUESTIONS_ES[5].options[1].weights },
      { label: "8 to 15 years", weights: QUESTIONS_ES[5].options[2].weights },
      { label: "More than 15 years", weights: QUESTIONS_ES[5].options[3].weights },
    ],
  },
];

export const SKILLS_BY_LANG = { es: SKILLS_ES, en: SKILLS_EN };
export const QUESTIONS_BY_LANG = { es: QUESTIONS_ES, en: QUESTIONS_EN };

export function computeResult(answers, lang = "es") {
  const skills = SKILLS_BY_LANG[lang] || SKILLS_ES;
  const questions = QUESTIONS_BY_LANG[lang] || QUESTIONS_ES;
  const totals = {};
  questions.forEach((q) => {
    const idx = answers[q.id];
    if (idx == null) return;
    const opt = q.options[idx];
    if (!opt) return;
    Object.entries(opt.weights).forEach(([k, v]) => {
      totals[k] = (totals[k] || 0) + v;
    });
  });
  return Object.entries(totals)
    .map(([key, score]) => ({ key, score, ...skills[key] }))
    .sort((a, b) => b.score - a.score)
    .slice(0, 5);
}
